/////////////////////////////////////////////////////////////////////////////////////////////
// Copyright 2026 Garmin International, Inc.
// Licensed under the Flexible and Interoperable Data Transfer (FIT) Protocol License; you
// may not use this file except in compliance with the Flexible and Interoperable Data
// Transfer (FIT) Protocol License.
/////////////////////////////////////////////////////////////////////////////////////////////
// ****WARNING****  This file is auto-generated!  Do NOT edit this file.
// Profile Version = 21.218.0Release
// Tag = production/release/21.218.0-0-g96fee6d7
/////////////////////////////////////////////////////////////////////////////////////////////

package com.garmin.fit

import com.garmin.fit.types.*
import kotlin.time.Instant

/**
 * The FIT `ant_channel_id` message.
 *
 * A thin typed view over [Mesg]: the accessors below read and write the same
 * numbered fields the untyped API exposes, so nothing is hidden by using them.
 */
public open class AntChannelIdMesg : Mesg {
    public constructor() : super("AntChannelId", Profile.MesgNum.ANT_CHANNEL_ID)

    public constructor(mesg: Mesg) : super(mesg)

    internal constructor(mesg: Mesg, adopt: Boolean) : super(mesg, adopt)

    /** channel_number. */
    public var channelNumber: UByte?
        get() = getFieldValue(CHANNEL_NUMBER_FIELD_NUM) as? UByte
        set(value) = setFieldValue(CHANNEL_NUMBER_FIELD_NUM, value)

    /** device_type. */
    public var deviceType: UByte?
        get() = getFieldValue(DEVICE_TYPE_FIELD_NUM) as? UByte
        set(value) = setFieldValue(DEVICE_TYPE_FIELD_NUM, value)

    /** device_number. */
    public var deviceNumber: UShort?
        get() = getFieldValue(DEVICE_NUMBER_FIELD_NUM) as? UShort
        set(value) = setFieldValue(DEVICE_NUMBER_FIELD_NUM, value)

    /** transmission_type. */
    public var transmissionType: UByte?
        get() = getFieldValue(TRANSMISSION_TYPE_FIELD_NUM) as? UByte
        set(value) = setFieldValue(TRANSMISSION_TYPE_FIELD_NUM, value)

    /** device_index. */
    public var deviceIndex: UByte?
        get() = getFieldValue(DEVICE_INDEX_FIELD_NUM) as? UByte
        set(value) = setFieldValue(DEVICE_INDEX_FIELD_NUM, value)

    public companion object {
        public const val CHANNEL_NUMBER_FIELD_NUM: UByte = 0u
        public const val DEVICE_TYPE_FIELD_NUM: UByte = 1u
        public const val DEVICE_NUMBER_FIELD_NUM: UByte = 2u
        public const val TRANSMISSION_TYPE_FIELD_NUM: UByte = 3u
        public const val DEVICE_INDEX_FIELD_NUM: UByte = 4u

        /**
         * The profile definition of every field of this message, with no values.
         *
         * Built once when this class is first touched, and handed out only as
         * copies, so the decoder pays for a message type it never meets nothing.
         */
        internal val PROTOTYPE_FIELDS: Map<Int, Field> = buildPrototypeFields()

        private fun buildPrototypeFields(): Map<Int, Field> {
            val fields = LinkedHashMap<Int, Field>()
            fields[0] = Field("ChannelNumber", 0u, BaseType.UINT8, 1.0, 0.0, "", false)
            fields[1] = Field("DeviceType", 1u, BaseType.UINT8Z, 1.0, 0.0, "", false)
            fields[2] = Field("DeviceNumber", 2u, BaseType.UINT16Z, 1.0, 0.0, "", false)
            fields[3] = Field("TransmissionType", 3u, BaseType.UINT8Z, 1.0, 0.0, "", false)
            fields[4] = Field("DeviceIndex", 4u, BaseType.UINT8, 1.0, 0.0, "", false)
            return fields
        }
    }
}
